import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { CRMType } from 'src/app/user-profile/shared/models';

@Component({
  selector: 'app-crm-synchronization-conversation-workflow-mappings',
  templateUrl: './crm-synchronization-conversation-workflow-mappings.component.html',
  styleUrls: ['./crm-synchronization-conversation-workflow-mappings.component.scss'],
})
export class CrmSynchronizationConversationWorkflowMappingsComponent implements OnInit {
  @Input() crmType: CRMType;
  @Input() configuration: any;
  @Input() freshData: any;
  @Input() organizationId: any;

  @Output() workflowMappingFromAlcmeonToSalesforceChanged: EventEmitter<any> = new EventEmitter();
  @Output() workflowMappingFromSalesforceToAlcmeonChanged: EventEmitter<any> = new EventEmitter();

  mappingsFromAlcmeonToSalesforceArray: FormArray = new FormArray([]);
  mappingsFromSalesforceToAlcmeonArray: FormArray = new FormArray([]);

  availableSfQueues = [];
  routingTagsItems = [];

  constructor(
    private alcmeonContextService: AlcmeonContextService,
    @Inject('DropdownItemsFactory') DropdownItemsFactory: any
  ) {
    const routingTags = this.alcmeonContextService
      .getCompany()
      .tags_groups.filter(tag_group => tag_group.is_routing === 1);
    this.routingTagsItems = DropdownItemsFactory.buildTagItems(routingTags)[0].items.flatMap(i => i.subitems);
  }

  ngOnInit() {
    if (!this.configuration.workflow_mappings) {
      this.configuration.workflow_mappings = {
        from_alcmeon_to_sf: [],
        from_sf_to_alcmeon: [],
      };
    }
    this.availableSfQueues = this.freshData.available_queues.map(aq => {
      return {
        id: aq.Id,
        label: aq.Name,
      };
    });
    (this.configuration.workflow_mappings.from_alcmeon_to_sf || []).forEach(({ team_tag_id, queue_id }) => {
      this.mappingsFromAlcmeonToSalesforceArray.push(this.addNewMappingGroup({ team_tag_id, queue_id }));
    });
    (this.configuration.workflow_mappings.from_sf_to_alcmeon || []).forEach(({ team_tag_id, queue_id }) => {
      this.mappingsFromSalesforceToAlcmeonArray.push(this.addNewMappingGroup({ team_tag_id, queue_id }));
    });

    this.mappingsFromAlcmeonToSalesforceArray.valueChanges.subscribe(value =>
      this.workflowMappingFromAlcmeonToSalesforceChanged.emit(value)
    );
    this.mappingsFromSalesforceToAlcmeonArray.valueChanges.subscribe(value =>
      this.workflowMappingFromSalesforceToAlcmeonChanged.emit(value)
    );
  }

  deleteMappingFromAlcmeonToSalesforce(index) {
    this.mappingsFromAlcmeonToSalesforceArray.removeAt(index);
  }

  addMappingFromAlcmeonToSalesforce(formArray: FormArray) {
    formArray.push(this.addNewMappingGroup({ team_tag_id: null, queue_id: null }));
  }

  deleteMappingFromSalesforceToAlcmeon(index) {
    this.mappingsFromSalesforceToAlcmeonArray.removeAt(index);
  }

  addMappingFromSalesforceToAlcmeon(formArray: FormArray) {
    formArray.push(this.addNewMappingGroup({ team_tag_id: null, queue_id: null }));
  }

  private addNewMappingGroup({ team_tag_id, queue_id }) {
    return new FormGroup({
      team_tag_id: new FormControl(team_tag_id, Validators.required),
      queue_id: new FormControl(queue_id, Validators.required),
    });
  }
}
